import { Box, Button, Flex, Spinner, Text } from '@chakra-ui/react';
import { InformationIcon, LeftArrowIcon, SaveWhiteIcon } from '@assets/icons/index';

export const CardHeader = ({ title = 'Konfigurasi - Parahub', ...props }) => {
    return (
        <Box
            p={'16px 24px'}
            bg={'semantic.100'}
            border={'1px solid'}
            borderColor={'neutral.200'}
            borderRadius={'8px'}
            {...props}
        >
            <Flex justifyContent={'space-between'}>
                <Box alignSelf={'start'} mt={'4px'} onClick={props.onNavigateBack} cursor={'pointer'}>
                    <LeftArrowIcon />
                </Box>
                <Box flex={1} ml={'12px'}>
                    <Text fontWeight={700} fontSize={'20px'}>
                        {title}
                    </Text>
                    <Flex gap={'8px'}>
                        <InformationIcon />
                        <Text>Tidak ada pembaruan terbaru untuk saat ini.</Text>
                    </Flex>
                </Box>
                <Box alignSelf={'center'}>
                    {props.isShowButton && (
                        <>
                            {props.isLoading && (
                                <Button variant={'outline'} mr={'12px'} onClick={props.onCancel}>
                                    Batalkan
                                </Button>
                            )}
                            <Button onClick={props.onSubmit} disabled={props.isLoading}>
                                {props.isLoading ? <Spinner /> : <SaveWhiteIcon />}
                                Simpan
                            </Button>
                        </>
                    )}
                </Box>
            </Flex>
        </Box>
    );
};
